var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.copySimpleHtml}},[_c('v-list-item-icon',{staticClass:"mr-2"},[_c('v-icon',[_vm._v("mdi-content-copy")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("簡易HTMLコピー")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }